import { summaryActions } from '../actions';

export default function summary ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case summaryActions.SET_SUMMARY: return setSummaryReducer( newState, action );
        case summaryActions.GENERAL_SUMMARY_REQUEST: return setSummaryReducer(newState, action);
        case summaryActions.GENERAL_SUMMARY_SUCCESS: return createAndEditReducer(newState, action);
        // case summaryActions.DELETE_SUMMARY_SUCCESS: return deleteReducer(newState, action);
        case summaryActions.GENERAL_SUMMARY_ERROR: return setSummaryReducer(newState, action);
        default: return newState;
    }
}

function setSummaryReducer ( newState, action ) {
    delete action.type;
    return Object.assign( newState, { ...action } );
}

function createAndEditReducer ( newState, action ) {
    delete action.type;

    const summary = {...action};
    const noData = (summary.body === undefined || summary.body === null || '');
    newState.body = noData ? null : summary.body;
    newState.person_id = summary.personId;
    newState.noData = summary.noData;
    return newState;
}


// function deleteReducer(newState, action) {
//     delete action.type;
//
//     const summary = {...newState};
//     summary.noData = true;
//     newState = summary;
//
//     return newState;
// }





// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/summary.js